var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../recoil/userState";
//utils
import * as CONST from "../../utils/Const";
import * as HTTPUTIL from "../../utils/api/HttpUtil";
import clog from "../../utils/logUtils";
import * as CUTIL from "../../utils/commUtils";
/**
 * @brief EHP 운영 관리 사용자 Tree 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
function NormalTree(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    // props
    const isMobile = props.isMobile;
    const curTree = props.curTree;
    const setParentCurTree = props.setCurTree;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const setParentWorkMode = props.setWorkMode;
    const workMode = props.workMode;
    const tabType = props.tabType;
    const setParentPopWin = props.setPopWin;
    //
    //clog("IN ADMIN TREE : ADMINTREE : " + adminType + " : " + tabType);
    //화면 이동
    const navigate = useNavigate();
    //
    const [userTree, setUserTree] = useState([]);
    const { data: resInfo, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/usertree`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: adminType + workMode + curTree.reload
    });
    useEffect(() => {
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, resInfo);
        //clog("IN TREE : RESLT CHECK : " + ERR_URL + " : " + isLoading + " : " + JSON.stringify(resInfo));
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (resInfo /* !isLoading */) {
            //clog("IN ADMINTREE : RES : " + JSON.stringify(resInfo.body));
            if (resInfo.codeNum == CONST.API_200) {
                setUserTree(resInfo.body);
                setParentCurTree(adminType, Object.assign(Object.assign({}, curTree), { reload: false }));
            }
        }
    }, [resInfo, adminType, workMode]);
    //}, [resInfo])
    // 사업장 추가
    function onClickZoneList(e) {
        setParentAdminType("ZONE");
        if (userInfo.loginInfo.role !== CONST.USERROLE_ADMIN) {
            setParentWorkMode("LIST");
        }
        else { // ADMIN 경우, 사업장 추가 기능이 없어짐 => 검색영역으로 바뀜
            setParentWorkMode("LIST");
            //setParentWorkMode("ADMIN_CREATE");
        }
        CUTIL.jsopen_s_Popup(e, isMobile);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__left" },
            (tabType === "TAB_ZONE") && React.createElement("div", { className: "lnb__top" },
                React.createElement("button", { type: "button", 
                    //className="add__item active js-open-s"
                    className: `add__item js-open-s ${((adminType === "ZONE") && ((workMode === "LIST") || (workMode === "CREATE"))) ? "active" : ""}`, "data-pop": "pop-area-right", 
                    //data-pop="pop-area-right-page-info" // insert 후 뷰 이동 위해
                    onClick: (e) => onClickZoneList(e) },
                    React.createElement("span", null, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00"))),
            (userTree) && React.createElement("div", { className: "lnb" },
                React.createElement("ul", { className: "lnb-depth1" }, userTree.map((company, idx) => (React.createElement(ZoneTree, { key: `comp_${idx.toString()}`, tabType: props.tabType, company: company, zone: company.zone, curTree: props.curTree, setCurTree: props.setCurTree, isMobile: props.isMobile, adminType: props.adminType, workMode: props.workMode, setWorkMode: props.setWorkMode, setAdminType: props.setAdminType, setCurTabMenu: props.setCurTabMenu, setPopWin: props.setPopWin })))),
                " "),
            " ")));
}
;
export default NormalTree;
function ZoneTree(props) {
    //const company = props.company;
    //const zoneTree = (props.company.hasOwnProperty("zone"))?props.company.zone:[];
    const zoneTree = props.zone;
    const curTree = props.curTree;
    const setParentCurTree = props.setCurTree;
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentAdminType = props.setAdminType;
    const tabType = props.tabType;
    const setParentPopWin = props.setPopWin;
    //clog("IN ADMIN TREE : ZONE : " + props.setAdminType);
    //clog("IN ZONETREE : INIT : " + JSON.stringify(curTree));
    function onClickZone(e, zone) {
        setParentPopWin("pop-area-right-page-info", null);
        e.stopPropagation();
        //clog("IN NORMAL TREE : onClickZone : " + e.target.tagName + " : " + e.target.getAttribute("data-val"));
        setParentCurTree("ZONE", Object.assign(Object.assign({}, curTree), { company: { "companyId": props.company.companyId, "companyName": props.company.companyName, }, zone: { "zoneId": zone.zoneId, "zoneName": zone.zoneName } }));
        setParentWorkMode("READ");
    }
    // 상세사업장 추가 - subZone 항목이 없을 경우
    function onClickSubZoneInsert(e) {
        e.stopPropagation();
        clog("IN SUBZONETREE : onClickSubZoneInsert : " + e.target.tagName);
        setParentAdminType("SUBZONE");
        setParentWorkMode("CREATE");
        CUTIL.jsopen_s_Popup(e, isMobile);
    }
    function handleOnClickRequest(e, zone) {
        //clog("handleOnClickRequest : " + JSON.stringify(zone));
        setParentPopWin("pop-reason", React.createElement(RequestPopup, { htmlHeader: React.createElement("h1", null, "\uC0AC\uC5C5\uC7A5 \uC694\uCCAD \uCDE8\uC18C"), zoneInfo: zone, setCurTree: props.setCurTree, setWorkMode: props.setWorkMode }));
        CUTIL.jsopen_Popup(e);
    }
    function handleOnClickReason(e, zone) {
        //clog("handleOnClickReason : " + JSON.stringify(zone));
        setParentPopWin("pop-reason", React.createElement(ReasonPopup, { htmlHeader: React.createElement("h1", null, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00 \uC694\uCCAD"), zoneInfo: zone, setCurTree: props.setCurTree, setWorkMode: props.setWorkMode }));
        CUTIL.jsopen_Popup(e);
    }
    return (React.createElement(React.Fragment, null, (zoneTree) && zoneTree.map((zone, idx) => ((zone.approval === 2)
        ? React.createElement("li", { key: `zone_${idx.toString()}`, className: `${((curTree) && ((curTree.zone.zoneId === zone.zoneId))) ? "active" : ""}`, onClick: (e) => { onClickZone(e, zone); }, "data-val": "ZONE" },
            React.createElement("p", null,
                React.createElement("a", { href: "#", className: `js-open-s ${(zone.isontree) ? "" : "tree-off"}`, "data-pop": (tabType === "TAB_ZONE") ? "pop-area-right-page-info" : "", onClick: (e) => (tabType === "TAB_ZONE") && CUTIL.jsopen_s_Popup(e, isMobile) },
                    React.createElement("span", null, props.company.companyName),
                    React.createElement("span", null, zone.zoneName))),
            React.createElement("ul", { className: "lnb-depth2" },
                (!zone.hasOwnProperty("subZone")) && // 상세사업장 추가 - subZone 항목이 없을 경우
                    React.createElement("li", { key: `no_szone`, className: "" }, (tabType === "TAB_ZONE") && /*(adminType==="ZONE")&&*/
                        React.createElement("button", { type: "button", className: `add__item js-open-s ${((adminType === "SUBZONE") && (workMode === "CREATE")) ? "active" : ""}`, "data-pop": "pop-area-right-page-info", onClick: (e) => onClickSubZoneInsert(e) },
                            React.createElement("span", null, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uCD94\uAC00"))),
                (zone.hasOwnProperty("subZone")) &&
                    React.createElement(SubZoneTree, { key: `zone_${idx.toString()}`, tabType: props.tabType, company: props.company, zone: zone, subZone: zone.subZone, curTree: props.curTree, setCurTree: props.setCurTree, isMobile: props.isMobile, adminType: props.adminType, workMode: props.workMode, setWorkMode: props.setWorkMode, setAdminType: props.setAdminType, setCurTabMenu: props.setCurTabMenu })))
        : (zone.approval === 1)
            ? React.createElement("li", { key: `zone_${idx.toString()}`, className: "add__wait" },
                React.createElement("span", { className: "name" },
                    React.createElement("span", null, props.company.companyName),
                    React.createElement("span", null, zone.zoneName)),
                React.createElement("span", { className: "add__step" },
                    React.createElement("span", { className: "txt" }, "\uCD94\uAC00 \uC694\uCCAD \uC911"),
                    React.createElement("button", { type: "button", className: "js-open", "data-pop": "pop-reason", onClick: (e) => handleOnClickRequest(e, zone) },
                        React.createElement("span", { "data-pop": "pop-reason" }, "\uCDE8\uC18C"))))
            : React.createElement("li", { key: `zone_${idx.toString()}`, className: "add__wait" },
                React.createElement("span", { className: "name" },
                    React.createElement("span", null, props.company.companyName),
                    React.createElement("span", null, zone.zoneName)),
                React.createElement("span", { className: "add__step fail" },
                    React.createElement("span", { className: "txt" }, "\uC694\uCCAD \uBC18\uB824"),
                    React.createElement("button", { type: "button", className: "js-open", "data-pop": "pop-reason", onClick: (e) => handleOnClickReason(e, zone) },
                        React.createElement("span", { "data-pop": "pop-reason" }, "\uC0AC\uC720 \uD655\uC778"))))))));
}
function SubZoneTree(props) {
    const subZoneTree = props.subZone;
    const curTree = props.curTree;
    const setParentCurTree = props.setCurTree;
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentAdminType = props.setAdminType;
    const tabType = props.tabType;
    //
    function onClickSubZone(e, subZone) {
        e.stopPropagation();
        var actTag = (e.target.tagName === "A") ? e.currentTarget : e.target;
        clog("onClickSubZone : " + actTag.tagName + " : " + actTag.getAttribute("data-val"));
        setParentCurTree("SUBZONE", Object.assign(Object.assign({}, curTree), { subZone: { "subZoneId": subZone.subZoneId, "subZoneName": subZone.subZoneName } }));
        setParentWorkMode("READ");
    }
    // 상세사업장 추가
    function onClickSubZoneInsert(e) {
        e.stopPropagation();
        clog("IN SUBZONETREE : onClickSubZoneInsert : " + e.target.tagName);
        setParentAdminType("SUBZONE");
        setParentWorkMode("CREATE");
        CUTIL.jsopen_s_Popup(e, isMobile);
    }
    // Room 항목이 없을 경우
    function onClickRoomInsert(e) {
        e.stopPropagation();
        clog("IN ROOMTREE : onClickRoomInsert : " + e.target.tagName);
        setParentWorkMode("CREATE");
        setParentAdminType("ROOM");
        CUTIL.jsopen_s_Popup(e, isMobile);
    }
    return (React.createElement(React.Fragment, null, (subZoneTree) && subZoneTree.map((subZone, idx) => (React.createElement("li", { key: `szone_${idx.toString()}`, className: `${((curTree) && (curTree.subZone.subZoneId === subZone.subZoneId)) ? ((adminType === "SUBZONE") && (workMode !== "CREATE")) ? "active" : "" : ""}`, onClick: (e) => { onClickSubZone(e, subZone); }, "data-val": "SUBZONE" },
        (idx === 0) && (tabType === "TAB_ZONE") && React.createElement("button", { type: "button", className: `add__item js-open-s ${((adminType === "SUBZONE") && (workMode === "CREATE")) ? "active" : ""}`, "data-pop": "pop-area-right-page-info", onClick: (e) => onClickSubZoneInsert(e) },
            React.createElement("span", null, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uCD94\uAC00")),
        React.createElement("a", { href: "#", className: `js-open-s ${(subZone.isontree) ? "" : "tree-off"}`, "data-pop": (tabType === "TAB_ZONE") ? "pop-area-right-page-info" : "", onClick: (e) => (tabType === "TAB_ZONE") && CUTIL.jsopen_s_Popup(e, isMobile) }, subZone.subZoneName),
        React.createElement("ul", { className: `lnb-depth3 ${(tabType == "TAB_DEVICE") ? "no-btn" : ""} `, style: { "display": `${((curTree) && (curTree.subZone.subZoneId === subZone.subZoneId)) ? "" : "none"}` } },
            (!subZone.hasOwnProperty("room") && (tabType === "TAB_ZONE")) && /*(adminType === "SUBZONE") &&*/ // ROOM이 없을 경우
                React.createElement("li", { key: `noroom_`, className: "" },
                    React.createElement("button", { type: "button", className: `add__item js-open-s ${((adminType === "ROOM") && (workMode === "CREATE")) ? "active" : ""}`, onClick: (e) => onClickRoomInsert(e), "data-pop": "pop-area-right-page-info" },
                        React.createElement("span", null, "\uC804\uAE30\uC2E4 \uCD94\uAC00"))),
            (subZone.hasOwnProperty("room")) &&
                React.createElement(RoomTree, { key: `szone_${idx.toString()}`, tabType: props.tabType, company: props.company, zone: props.zone, subZone: props.subZone, room: subZone.room, curTree: props.curTree, setCurTree: props.setCurTree, isMobile: props.isMobile, adminType: props.adminType, workMode: props.workMode, setWorkMode: props.setWorkMode, setAdminType: props.setAdminType, setCurTabMenu: props.setCurTabMenu })))))));
}
function RoomTree(props) {
    const roomTree = props.room;
    const curTree = props.curTree;
    const setParentCurTree = props.setCurTree;
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentAdminType = props.setAdminType;
    const tabType = props.tabType;
    const setParentCurTabMenu = props.setCurTabMenu;
    function onClickRoom(e, room, tabType) {
        e.stopPropagation();
        var actTag = (e.target.tagName === "A") ? e.currentTarget : e.target;
        setParentCurTree("ROOM", Object.assign(Object.assign({}, curTree), { room: { "roomId": room.roomId, "roomName": room.roomName }, spg: { "spgId": "", "spgName": "" } }));
        if (tabType === "TAB_DEVICE") {
            setParentWorkMode("LIST");
        }
        else {
            setParentWorkMode("READ");
        }
    }
    // 사이트(ROOM) 추가
    function onClickRoomInsert(e) {
        e.stopPropagation();
        clog("IN ROOMTREE : onClickRoomInsert : " + e.target.tagName);
        setParentWorkMode("CREATE");
        setParentAdminType("ROOM");
        CUTIL.jsopen_s_Popup(e, isMobile);
    }
    // 기기등록 tab 및 목록으로 이동
    function onClickDeviceInsert(e) {
        e.stopPropagation();
        //mainlayout tab 데이터 확인 필요
        setParentCurTabMenu({ tabId: 1, tabName: "기기 등록 관리", tabType: "TAB_DEVICE" });
        setParentWorkMode("LIST");
        setParentAdminType("ROOM");
        CUTIL.jsopen_s_Popup(e, isMobile);
    }
    return (React.createElement(React.Fragment, null, (roomTree) && roomTree.map((room, idx) => (React.createElement("li", { key: `room_${idx.toString()}`, className: `${((curTree) && (curTree.room.roomId === room.roomId)) ? ((adminType === "ROOM") && (workMode !== "CREATE")) ? "active" : "" : ""}`, onClick: (e) => { onClickRoom(e, room, tabType); }, "data-val": "ROOM" },
        (idx === 0) && (tabType === "TAB_ZONE") &&
            React.createElement("button", { type: "button", className: `add__item js-open-s ${((adminType === "ROOM") && (workMode === "CREATE")) ? "active" : ""}`, onClick: (e) => onClickRoomInsert(e), "data-pop": "pop-area-right-page-info" },
                React.createElement("span", null, "\uC804\uAE30\uC2E4 \uCD94\uAC00")),
        React.createElement("a", { href: "#", className: `js-open-s ${(room.isontree) ? "" : "tree-off"}`, "data-pop": (tabType === "TAB_DEVICE") ? "pop-list" : "pop-area-right-page-info", onClick: (e) => CUTIL.jsopen_s_Popup(e, isMobile) },
            React.createElement("span", null, room.roomName)),
        (tabType === "TAB_ZONE") &&
            React.createElement("ul", { className: "lnb-depth4", style: { "display": `${((curTree) && (curTree.room.roomId === room.roomId)) ? "block" : "none"}` } },
                React.createElement("li", { className: "" },
                    React.createElement("a", { href: "#", "data-pop": "pop-list", onClick: (e) => onClickDeviceInsert(e) }, "\uAE30\uAE30 \uB4F1\uB85D"))))))));
}
function RequestPopup(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //
    const zoneInfo = props.zoneInfo;
    const setParentCurTree = props.setCurTree;
    const setParentWorkMode = props.setWorkMode;
    //
    const [errorList, setErrorList] = useState([]);
    // 중앙 정렬
    useEffect(() => {
        var btnCommentClose = document.getElementById("pop-reason");
        btnCommentClose.setAttribute("style", `position: absolute; top:${(window.innerHeight - btnCommentClose.scrollHeight) / 2 + "px"}; left:${(window.innerWidth - btnCommentClose.scrollWidth) / 2 + "px"} `);
    });
    function onClickRequestCancel(e, zone) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "DELETE",
                "appPath": "/api/v2/product/usertree",
                appQuery: {
                    "productId": zone.zoneId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    //clog("IN TREE : ZONE-DELETE: ret : " + JSON.stringify(data.body));
                    setParentCurTree("ZONE", // 하위 삭제시 상위 호출
                    {
                        company: { "companyId": "", "companyName": "" },
                        zone: { "zoneId": "", "zoneName": "" },
                        subZone: { "subZoneId": "", "subZoneName": "" },
                        room: { "roomId": "", "roomName": "" },
                        reload: true
                    });
                    setParentWorkMode("READ");
                }
                else { // api if
                    // need error handle
                    alert(JSON.stringify(data.body.errorList[0].msg));
                    setErrorList(data.body.errorList);
                }
                CUTIL.jsclose_Popup("pop-reason");
            }
            //return data;
        });
    }
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-reason");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null,
                React.createElement("span", { className: "font-16" }, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00 \uC694\uCCAD\uC744 \uCDE8\uC18C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"),
                React.createElement("br", null),
                React.createElement("span", { className: "fontRegular" })),
            React.createElement("dl", null,
                React.createElement("dt", null),
                React.createElement("dd", null))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray btn-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button" /* className="btn-close" */, onClick: (e) => onClickRequestCancel(e, zoneInfo) },
                React.createElement("span", null, "\uD655\uC778")))));
}
function ReasonPopup(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //
    const zoneInfo = props.zoneInfo;
    const setParentCurTree = props.setCurTree;
    const setParentWorkMode = props.setWorkMode;
    //
    const [errorList, setErrorList] = useState([]);
    // 중앙 정렬
    useEffect(() => {
        var btnCommentClose = document.getElementById("pop-reason");
        btnCommentClose.setAttribute("style", `position: absolute; top:${(window.innerHeight - btnCommentClose.scrollHeight) / 2 + "px"}; left:${(window.innerWidth - btnCommentClose.scrollWidth) / 2 + "px"} `);
    });
    function onClickRequestCancel(e, zone) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "DELETE",
                "appPath": "/api/v2/product/usertree",
                appQuery: {
                    "productId": zone.zoneId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    //clog("IN TREE : ZONE-DELETE: ret : " + JSON.stringify(data.body));
                    CUTIL.jsclose_Popup("pop-reason");
                    setParentCurTree("ZONE", // 하위 삭제시 상위 호출
                    {
                        company: { "companyId": "", "companyName": "" },
                        zone: { "zoneId": "", "zoneName": "" },
                        subZone: { "subZoneId": "", "subZoneName": "" },
                        room: { "roomId": "", "roomName": "" },
                        reload: true
                    });
                    setParentWorkMode("READ");
                }
                else { // api if
                    // need error handle
                    alert(JSON.stringify(data.body.errorList));
                    CUTIL.jsclose_Popup("pop-reason");
                    setErrorList(data.body.errorList);
                }
            }
            //return data;
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null,
                React.createElement("span", { className: "font-16" }, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00 \uC694\uCCAD\uC774 \uBC18\uB824\uB418\uC5C8\uC2B5\uB2C8\uB2E4."),
                React.createElement("br", null),
                React.createElement("span", { className: "fontRegular" })),
            React.createElement("dl", null,
                React.createElement("dt", null, "\uBC18\uB824 \uC0AC\uC720"),
                React.createElement("dd", null, zoneInfo.deniedReason))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray btn-close", onClick: (e) => onClickRequestCancel(e, zoneInfo) },
                React.createElement("span", null, "\uC0AD\uC81C")),
            React.createElement("button", { type: "button" /* className="btn-close" */ },
                React.createElement("span", { onClick: (e) => CUTIL.jsclose_Popup("pop-reason") }, "\uD655\uC778")))));
}
